import styled from "styled-components";
export const LocationsWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
